import { createAction, props } from "@ngrx/store";

export const checkAuth = createAction("[Auth] checkAuth");
export const checkAuthComplete = createAction("[Auth] checkAuthComplete", props<{ authenticated: boolean }>());

export const login = createAction("[Auth] login", props<{ email: string; password: string }>());
export const loginComplete = createAction("[Auth] loginComplete", props<{ profile: any; authenticated: boolean }>());
export const loginFailure = createAction("[Auth] loginFailure", props<{ error: any }>());

export const logout = createAction("[Auth] logout");
export const logoutComplete = createAction("[Auth] logoutComplete");

export const setToken = createAction("[Auth] setToken", props<{ token: string }>());
